<template>
    <span>
        <v-row class="ma-0 container-side-padding mt-5 mt-sm-15">
            <v-breadcrumbs class="pa-0 diia-nav-breadcrumbs" :items="breadcrumbs_items">
            <template v-slot:divider>
                <span color="black">|</span>
            </template>
            </v-breadcrumbs>
        </v-row>
        <v-row class="ma-0 mt-6 container-side-padding">
            <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="7">
                <h1 class="diia-nav-menu-h1-header-breadcrumbs" v-if="$config.query_params.env == 'SEVDEIR'">{{ header_text }} (пром)</h1>
                <h1 class="diia-nav-menu-h1-header-breadcrumbs" v-if="$config.query_params.env == 'SEVDEIR-TEST'">{{ header_text }} (тест)</h1>
            </v-col>
            <v-col class="ma-0 pa-0 mt-3 mt-lg-0 align-center" cols="12" xs="12" sm="12" md="12" lg="5">
                <v-row class="ma-0 pa-0 flex-column flex-sm-row justify-start justify-lg-end pt-4">
                <v-btn style="box-shadow: 2px 1000px 1px #fff inset !important" class="btn_outlined_diia small mb-3" elevation="0" @click="switchEnv">Змінити середовище</v-btn>
                <v-btn style="box-shadow: 2px 1000px 1px #fff inset !important" class="btn_outlined_diia small ml-0 ml-sm-3" elevation="0" @click="show_headers = !show_headers; show_filters = false;">Поля</v-btn>
                <v-btn style="box-shadow: 2px 1000px 1px #fff inset !important" class="btn_outlined_diia small ml-0 ml-sm-3" elevation="0" @click="show_filters = !show_filters; show_headers = false;">Фільтри</v-btn>
                </v-row>
            </v-col>
        </v-row>
        <div style="height: 40px;" class="d-none d-sm-block" v-if="!show_filters"></div>
        <div style="height: 40px;" class="d-none d-lg-block" v-if="show_filters"></div>
        <div style="height: 30px;" class="d-none d-sm-block d-md-block d-lg-none" v-if="show_filters"></div>
        <div style="height: 30px;" class="d-block d-sm-none"></div>

        <v-row class="ma-0 mb-10 container-side-padding">
            <v-chip-group
                active-class="primary--text" column
            >
                <v-chip
                    v-for="tag in tags"
                    :key="tag.uuid"
                    dense
                    >
                    <b>{{tag.name}}</b>: {{tag.value}}
                </v-chip>
            </v-chip-group>
        </v-row>


        <v-row class="ma-0 top-margin-bottom-header-reponsive container-side-padding">
            <v-col class="pa-0" cols="12" :lg="(show_filters || show_headers) ? 8 : 12" order="3" order-sm="3" order-md="3" order-lg="1">
            <v-data-table
                locale="uk-UA"
                :headers="list_headers"
                :items="list_items"
                :items-per-page="10"
                :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                @click:row="onClickDetailSelect"
                mobile-breakpoint="1"
                :loading="list_loading"
                loading-text="Виконується запит..."
                class="elevation-0 pa-0 data-table-design-catalog-list"
                :server-items-length="list_size"
                disable-sort
                hide-default-footer
                :item-class="itemListRowClass"
            >
                <template v-slot:header="{ props }">
                    <th v-for="head in props.headers" style="padding-right: 15px;" v-bind:key="head.value + head.text">
                        <v-text-field @focus="onFocus(list_search_fields[head.value])" @blur="onBlur(list_search_fields[head.value])" @keydown="keydownSearch" :label="head.text" dense class="v-colored-search-table" single-line :disabled="!head.searchable" v-model="list_search_fields[head.value]"></v-text-field>
                    </th>
                </template>
                <template v-slot:item.annotated_last_central_request_status="{ item }">
                    <span v-if="item.is_deleted == 'В архіві'">-</span>
                    <span v-else-if="item.annotated_last_central_request_status == 'ERROR'" class="diia-list-badge-error">Помилка</span>
                    <span v-else-if="item.annotated_last_central_request_status == 'SUCCESS'" class="diia-list-badge-success">Успіх</span>
                    <v-icon v-else-if="item.annotated_last_central_request_status == 'lock'" style="font-size: 18px; color: black; opacity: 0.6;">mdi-lock</v-icon>
                    <span v-else class="diia-list-badge-secondary">Невідомо</span>
                </template>
                <template v-slot:item.annotated_last_central_request_at="{ item }">
                    <span v-if="item.is_deleted == 'В архіві'">-</span>
                    <span v-else-if="item.annotated_last_central_request_at">{{ item.annotated_last_central_request_at }}</span>
                    <v-icon v-else-if="item.annotated_last_central_request_status == 'lock'" style="font-size: 18px; color: black; opacity: 0.6;">mdi-lock</v-icon>
                    <span v-else class="diia-list-badge-secondary">Невідомо</span>
                    <!-- <v-icon v-else style="font-size: 18px; color: black; opacity: 0.6;">mdi-lock</v-icon> -->
                </template>
            </v-data-table>
            <DiiaDatatableFooter @on-update="requestList" :button_text_hidden="show_filters || show_headers" :items_per_page.sync="list_items_per_page_input" :list_size="list_size" :current_page.sync="current_page_input"/>
            </v-col>
            <v-col v-show="show_filters || show_headers" cols="12" md="1" order-sm="3" order-md="1">
            </v-col>
            <v-col class="filter-side-padding offset-md-1 pa-0 ma-0" v-show="show_headers" cols="12" lg="3" order="1" order-sm="1" order-md="1" order-lg="3">
                <ListHeadersModifier :key="filterKey" @on-export-to-excel="exportToExcel" @on-export-to-csv="exportToCSV" @copy-mode-switch="copyModeSwitch" @on-headers-update="updateHeaders" :list_data="list_items" :object_type="object_type"/>
                <div style="height: 30px;" class="d-block d-lg-none"></div>
            </v-col>
            <v-col class="filter-side-padding offset-md-1 pa-0 ma-0" v-show="show_filters" cols="12" lg="3" order="1" order-sm="1" order-md="1" order-lg="3">
                <ListFilterCardNew :key="filterKey" @on-filters-clear="clearFilters" @on-filters-apply="updateFilters" :object_type="object_type"/>
                <div style="height: 30px;" class="d-block d-lg-none"></div>
            </v-col>
        </v-row>
    </span>
</template>



<script>
/* eslint-disable */
import ListFilterCardNew from "./ListFilterCardNew";
import ListHeadersModifier from "./ListHeadersModifier";
import DiiaDatatableFooter from "./DiiaDatatableFooter";
export default {
  name: "CatalogList",
  components: {
      ListFilterCardNew,
      DiiaDatatableFooter,
      ListHeadersModifier,
  },
  props: [
    'object_type', 
    'header_text',
    'breadcrumbs_items',
    'list_headers', 
    'list_items', 
    'list_loading', 
    'list_size', 
    'list_search_fields', 
    'list_items_per_page', 
    'current_page'
  ],
  data: () => ({
    show_filters: false,
    show_headers: false,
    filterKey: 50000,
    current_value: '',
    tags: [],
    copyMode: false,
  }),
    created: function () {
        
    },
    computed: {
        list_items_per_page_input: {
            get: function() {
                return this.list_items_per_page;
            },
            set: function(newValue) {
                this.$emit('update:list_items_per_page', newValue);
            }   
        },

        current_page_input: {
            get: function() {
                return this.current_page;
            },
            set: function(newValue) {
                this.$emit('update:current_page', newValue);
            }   
        },
    },
    methods: {
        itemListRowClass(item) {
            return item.display_active !== null && item.display_active !== undefined && !item.display_active ? 'data-table-row-unactive' : '';
        },
        switchEnv() {
            if (this.$config.query_params.env == 'SEVDEIR') {
                this.$config.query_params.env = 'SEVDEIR-TEST';
                this.$router.replace({name: this.$route.name, query: this.$config.query_params});
                this.$router.go();
            } else {
                this.$config.query_params.env = 'SEVDEIR';
                this.$router.replace({name: this.$route.name, query: this.$config.query_params});
                this.$router.go();
            }
        },
        keydownSearch(key) {
            this.keycode = key.keyCode;
            if (key.keyCode == 13) {
                this.$emit('requestList');
            }
        },
        onFocus(current_value) {
            this.current_value = current_value;
        },
        onBlur(current_value) {
            if (current_value != this.current_value) {
                this.$emit('requestList');
            }
        },
        clearFilters() {
            this.$emit('clearFilters', this.object_type);
            this.tags = [];
            this.show_filters = false;
            this.filterKey += 1;
            window.scrollTo(0, 0);
        },
        updateFilters(object_type, display_values) {
            this.tags = display_values;
            this.show_filters = false;
            window.scrollTo(0, 0);
            this.$emit('updateFilters', this.object_type);
        },
        requestList() {
            this.$emit('requestList');
        },
        updateHeaders() {
            this.$emit('updateHeaders');
        },
        exportToExcel() {
            this.$emit('exportToExcel');
        },
        exportToCSV() {
            this.$emit('exportToCSV');
        },
        copyModeSwitch(copyModeEnabled) {
            this.copyMode = copyModeEnabled;
        },
        onClickDetailSelect(val) {
            if (!this.copyMode)
                this.$emit('onClickDetailSelect', val);
        }
    }
}
</script>